import React, {useEffect} from 'react'
import Footer from '../components/Footer';
import Header from '../pages/Home/components/Header'
import LoggedInUserHeader from '../components/Header/LoggedInUserHeader'
import {useSelector} from 'react-redux';
import { animateScroll } from 'react-scroll';

const PrivacyPolicy = () => {
    const isAuthenticated = useSelector(
        (state) => state.basicInfo.isAuthenticated
    );

    useEffect(()=>{
        animateScroll.scrollToTop({ duration: 300 });
    },[])

    return (
        <div className="clint-body privacy-policy-page">
            <div>
                {
                    isAuthenticated ?
                    <LoggedInUserHeader/> :
                    <Header/> 
                }



            <section className="transaction-history">
                <div className="container theme-section">
                    <h1 className="tr-title text-center"> Privacy Policy </h1>
                    
                    <div className='privacy-content'>

                        <b>Effective Date: 01/01/2025</b>

                        <br/>
                        <br/>

                        At Poncore, a product of Padmore Global Connections (PGC), we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines the types of personal and non-personal information we collect, how we use it, and how we safeguard your data. By accessing or using our website, https://www.poncore.com, you agree to the collection and use of information in accordance with this policy. This policy is designed to comply with applicable privacy laws, including the United States' General Data Protection Regulation (GDPR) and the Ghana Data Protection Act, 2012 (Act 843).
                    
                        <br/>
                        <br/>

                        <b>1. Information We Collect</b> 
                        <br/>
                        We collect both personal and non-personal information when you visit or interact with our website:
                        <br/>

                        <ul>
                            <li>
                                <b>Personal Information: </b> 
                                This may include your name, email address, phone number, billing information, and other personal identifiers you voluntarily provide when signing up for our services, filling out forms, or engaging with customer support.
                            </li>
                            <li>
                                <b>Non-Personal Information: </b> 
                                This includes your IP address, browser type, device type, operating system, and other tracking data that helps us improve the performance and functionality of our website.
                            </li>
                        </ul>


                        <br/>

                        <b>2. How We Use Your Information</b> 
                        <br/>
                        We use the information we collect for various purposes, including:
                        <br/>

                        <ul>
                            <li>
                                <b>Providing Services: </b> 
                                To operate and improve the Poncore Dispatch Marketplace, ensuring smooth transaction processing and effective customer service.
                            </li>
                            <li>
                                <b>Communication: </b> 
                                To send you updates, notifications, marketing communications, and promotions, provided you have consented to receive them.
                            </li>
                            <li>
                                <b>Personalization: </b> 
                                To enhance your user experience and tailor our services to meet your preferences and needs.
                            </li>
                            <li>
                                <b>Legal Compliance: </b> 
                                To comply with applicable laws, regulations, and legal obligations in both the U.S. and Ghana.
                            </li>
                        </ul>

                        <br/>

                        <b>3. How We Protect Your Information</b> 
                        <br/>
                        We employ a range of security measures, including encryption, secure servers, and access controls, to protect your personal information. While we make every effort to safeguard your data, please understand that no method of online transmission or storage is completely secure. However, we are committed to maintaining the confidentiality and integrity of your personal data.
                        <br/>
                        <br/>



                        <b>4. Sharing Your Information</b> 
                        <br/>
                        We do not sell, rent, or share your personal data with third parties for their marketing purposes without your explicit consent. However, we may share your information in the following situations:
                        <br/>

                        <ul>
                            <li>
                                <b>With Service Providers: </b> 
                                We may share personal data with third-party vendors who provide services on our behalf, such as payment processing, hosting, analytics, and customer support. These providers are contractually obligated to protect your data and use it only for the purposes for which it was provided.
                            </li>
                            <li>
                                <b>For Legal Compliance: </b> 
                                We may disclose your information when required by law, or if we believe it is necessary to comply with a legal obligation, protect our rights, investigate fraud, or respond to lawful requests by public authorities (including national security or law enforcement).
                            </li>
                            <li>
                                <b>Business Transfers: </b> 
                                In the event of a merger, acquisition, or sale of assets, your personal data may be transferred to the new owner. We will notify you if such a transfer occurs and update our privacy policy accordingly.
                            </li>
                        </ul>


                        <br/>
                        <br/>

                        
                        <b>5. Cookies and Tracking Technologies</b> 
                        <br/>
                        
                        We use cookies and similar tracking technologies to enhance user experience and analyze website performance. Cookies are small data files placed on your device when you visit our site. They help us remember your preferences and improve your browsing experience. You can manage or disable cookies through your browser settings; however, some features of our website may not work properly if cookies are disabled.
We also use third-party analytics tools, including Google Analytics, to help us analyze site traffic and usage patterns. These third parties may collect information about your online activities, but we do not control their tracking technologies.

                        <br/>
                        <br/>

                        

                        <b>6. Your Rights and Choices</b> 
                        <br/>
                        As a user, you have the following rights regarding your personal information: 
                        <br/>

                        <ul>
                            <li>
                                <b>Access: </b> 
                                You have the right to request access to the personal data we hold about you.
                            </li>
                            <li>
                                <b>Correction: </b> 
                                You can request correction of inaccurate or incomplete data.
                            </li>
                            <li>
                                <b>Deletion: </b> 
                                You may request the deletion of your personal data, subject to legal requirements.
                            </li>
                            <li>
                                <b>Opt-Out: </b> 
                                You may opt-out of receiving promotional emails and marketing communications by clicking the unsubscribe link in our emails or by contacting us directly.
                            </li>
                        </ul>

                        <br/>

                        For users in the United States, you also have the right under the California Consumer Privacy Act (CCPA) to request access to, delete, or opt-out of the sale of your personal information.

                        <br/>

                        For users in Ghana, you have the right to request access to your data, correct inaccuracies, and request deletion in accordance with the Ghana Data Protection Act, 2012 (Act 843). We are committed to responding to your requests in a timely and appropriate manner.

                        <br/>

                        To exercise your rights, please contact us using the contact information below.

                        <br/>
                        <br/>

                        <b>7. Children’s Privacy</b> 
                        <br/>
                        
                        Poncore does not knowingly collect or solicit personal data from children under the age of 13 in the United States or children under 16 in Ghana. If we become aware that we have collected such data, we will take immediate steps to delete it. If you are a parent or guardian and believe we have collected information from a child, please contact us.

                        <br/>
                        <br/>


                        <b>8. International Data Transfers</b> 
                        <br/>
                        
                        If you are located outside the United States or Ghana, please be aware that your personal data may be transferred to, and stored on, servers located in the United States or other countries. By using our website, you consent to such transfers, subject to the appropriate safeguards as required by applicable data protection laws.

                        <br/>
                        <br/>


                        <b>9. Changes to This Privacy Policy</b> 
                        <br/>
                        
                        We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. When we make changes, we will update the "Effective Date" at the top of this page and notify you if the changes are significant. We encourage you to review this Privacy Policy periodically to stay informed about how we are protecting your information.

                        <br/>
                        <br/>


                        <b>10. Contact Us</b> 
                        <br/>
                        
                        <p>If you have any questions or concerns about this Privacy Policy, or if you wish to exercise your privacy rights, please contact us:</p>

                        <b>Padmore Global Connections</b>
                        <p>Attn: Poncore Dispatch Market Place</p>
                        <p>Email: padmore.ayim@pgc-connect.com</p>
                        <p>Phone: 240-478-2730</p>
                        <p>Address: 1481 Osage Road, North Brunswick, NJ 08902</p>

 

                        <br/>
                        <br/>


                        
                    </div>
                </div>
            </section>
            </div>
            <Footer/>
        </div>
    )
}

export default PrivacyPolicy;